import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Button,
  Heading,
  Preloader,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AssociateAccountInProgress = ({
  login,
  onClose,
  isAccountLinkCanceling,
}) => {
  if (isAccountLinkCanceling) {
    return (
      <>
        <Heading level={1}>
          <I18n path="settings.numberManagement.associatingAccount.accountLinkIsCanceling" />
        </Heading>
        <Preloader
          className={cx('spinner')}
          size="80"
        />
      </>
    );
  }

  return (
    <>
      <Heading level={1}>
        <I18n path="settings.numberManagement.associatingAccount.linkRequestIsSentTitle" />
      </Heading>
      <Heading className={cx('subtitle')} level={5}>
        <I18n
          path="settings.numberManagement.associatingAccount.linkRequestIsSent"
          vars={{ login }}
        />
      </Heading>
      <Button
        className={['big', cx('popupButton')]}
        onClick={onClose}
      >
        <I18n path="common.continueWorking" />
      </Button>
    </>
  );
};

AssociateAccountInProgress.propTypes = {
  login: PropTypes.string,
  onClose: PropTypes.func,
  isAccountLinkCanceling: PropTypes.bool,
};

export default AssociateAccountInProgress;
